import { getTravleDetailR } from '@/axios/api'

const travleDetailR = {
  state: {
    travleDetailR: {}
  },
  mutations: {
    SET_TRAVLEDETAILR (state, travleDetailR) {
      state.travleDetailR = travleDetailR
    }
  },
  actions: {
    TRAVLEDETAILR ({ commit }, params) {
      getTravleDetailR(params).then(res => {
        this.state.travleDetailR = res.data
      })
    }
  }
}

export default travleDetailR



// WEBPACK FOOTER //
// ./src/store/modules/getTravleDetailR.js